// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"9e6fdaea","732":"6e7614a3","977":"42dd1e34"}[chunkId] + ".chunk.js";
};